import React from 'react';

const Quote = () => (
  <div className="quote main">
    Mathematics is not about numbers, equations, computations, or algorithms: it
    is about understanding. –William Paul Thurston
  </div>
);
export default Quote;
